var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import Vue from 'vue';
import Component from 'vue-class-component';
import { CTRL_KEY_LABEL, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import { getCompPathParentInfo } from "../../lib/utils";
import { getCompActionRenderType } from './utils/compActions';
import { Watch } from 'vue-property-decorator';
const SIMPLIFIED_KEY = 'uicore:action:simplified';
// 放在组件框顶部的那种
let CompActionBar = class CompActionBar extends Vue {
  constructor() {
    super(...arguments);
    this.simplifiedAction = false;
    this.allowOpenContextMenu = true;
    this.pop = false;
  }
  handleContextMenuChange(newVal, oldVal) {
    if (!newVal && oldVal) {
      this.allowOpenContextMenu = false;
      setTimeout(() => this.allowOpenContextMenu = true, 500);
    } else {
      this.allowOpenContextMenu = true;
    }
  }
  get contextMenuOpen() {
    return !!this.designer.contextMenuContent;
  }
  get compPath() {
    return this.designer.compPath;
  }
  get compActions() {
    const original = this.designer.getActiveCompActions('actionBar');
    const ans = [...original];
    const actions = ans.concat(this.actionBarDefaultActions);
    if (this.simplifiedAction) {
      return actions.filter(item => {
        var _item$place;
        return item === null || item === void 0 || (_item$place = item.place) === null || _item$place === void 0 ? void 0 : _item$place.includes('simplifiedActionBar');
      });
    }
    return actions;
  }
  get compName() {
    return this.uc.getLayoutName(this.designer.activeComp);
  }
  /**
   * 用于 ActionBar 的默认 actions（会含有名字、删除组件、修改ID等通用入口）
   */
  get actionBarDefaultActions() {
    const {
      activeComp
    } = this.designer;
    if (!activeComp) return [];
    const ans = [];
    const {
      contextMenuOpen
    } = this;
    ans.unshift({
      title: '',
      desc: contextMenuOpen ? '隐藏菜单' : '显示菜单',
      place: ['simplifiedActionBar'],
      icon: 'fa fa-ellipsis-v',
      highlighted: !!contextMenuOpen,
      execute: async e => {
        if (!this.allowOpenContextMenu) {
          this.allowOpenContextMenu = true;
          return;
        }
        if (!e) return;
        await this.$nextTick();
        this.designer.openContextMenuForActiveComp({
          clientX: e.clientX,
          clientY: e.clientY - e.offsetY + this.$el.offsetHeight
        });
      }
    });
    ans.unshift({
      title: '',
      desc: this.simplifiedAction ? '显示完整工具栏' : '简化工具栏',
      icon: this.simplifiedAction ? 'fa fa-eye-slash' : 'fa fa-eye',
      place: ['simplifiedActionBar'],
      execute: () => {
        this.simplifiedAction = !this.simplifiedAction;
      }
    });
    // 在 compPath变更时主动触发计算属性计算
    // 在放大🔍/缩小状态改变时计算属性响应
    this.designer.zoomFitState.currentCompPath = this.compPath;
    ans.push({
      title: '',
      desc: '删除',
      icon: 'fa fa-trash',
      place: ['simplifiedActionBar'],
      execute: () => this.designer.deleteActiveComp()
    });
    if (this.compPath) {
      ans.splice(-1, 0, {
        title: '',
        desc: `选中父组件 (${CTRL_KEY_LABEL}+←)`,
        icon: 'fa fa-level-up',
        execute: () => this.designer.selectParent()
      });
    }
    return ans;
  }
  get ancestorPaths() {
    let curCompPath = this.compPath;
    const paths = [];
    while (curCompPath) {
      const parentInfo = getCompPathParentInfo(curCompPath);
      if (parentInfo !== null) {
        curCompPath = parentInfo.parentCompPath;
        if (curCompPath) paths.push(curCompPath);
      } else {
        break;
      }
    }
    return paths;
  }
  get ancestorLayout() {
    return this.ancestorPaths.map(path => this.designer.getCompAtPath(path)).filter(el => el !== null);
  }
  get ancestorNameList() {
    return this.ancestorLayout.map(comp => {
      const name = this.uc.getLayoutName(comp);
      const regRes = name.match(/\(.*?\)/);
      if (regRes !== null && regRes[0]) {
        const innerName = regRes[0];
        return innerName.slice(1, innerName.length - 1);
      }
      return name;
    });
  }
  created() {
    this.simplifiedAction = JSON.parse(localStorage.getItem(SIMPLIFIED_KEY) || '{"value":false}').value;
    this.$watch(() => this.simplifiedAction, value => {
      localStorage.setItem(SIMPLIFIED_KEY, JSON.stringify({
        value
      }));
    });
  }
  mounted() {
    this.$emit('updated');
  }
  updated() {
    this.$emit('updated');
  }
  handleActiveBarFocus() {
    var _this$designer;
    const el = (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.$refs) === null || _this$designer === void 0 ? void 0 : _this$designer.editZone;
    if (el) el.focus();
  }
  showPop() {
    if (!this.pop) this.openTimeId = setTimeout(() => this.pop = true, 300);else clearTimeout(this.closeTimeId);
  }
  closePop() {
    if (this.pop) this.closeTimeId = setTimeout(() => this.pop = false, 300);else clearTimeout(this.openTimeId);
  }
  selectAncestor(ancestor) {
    this.designer.compPath = ancestor;
  }
  hightlight(ancestor) {
    this.designer.setHighlight(ancestor, 'normal');
  }
  deHighlight(ancestor) {
    this.designer.setHighlight(ancestor, false);
  }
  render() {
    const h = arguments[0];
    const {
      compPath,
      compActions,
      designer,
      compName,
      ancestorPaths,
      ancestorNameList,
      pop,
      simplifiedAction
    } = this;
    return h("div", {
      "class": "ucd-actionBar-out"
    }, [h("div", {
      "class": "ucd-actionBar",
      "directives": [{
        name: "show",
        value: !simplifiedAction
      }],
      "on": {
        "mouseenter": this.showPop,
        "mouseleave": this.closePop
      }
    }, [h("span", {
      "style": {
        cursor: ancestorNameList.length ? 'pointer' : 'default'
      }
    }, [" ", compName, " "]), h("div", {
      "class": 'ucd-actionBar-parentPopover',
      "style": {
        visibility: pop ? 'visible' : 'hidden',
        opacity: pop ? '1' : '0'
      }
    }, [ancestorPaths.map((ancestorPath, idx) => h("div", {
      "class": 'ucd-actionBar-parentPopover-item',
      "on": {
        "click": () => this.selectAncestor(ancestorPath),
        "mouseenter": () => this.hightlight(ancestorPath),
        "mouseleave": () => this.deHighlight(ancestorPath)
      }
    }, [h("span", [" ", ancestorNameList[idx], " "])]))])]), h("div", {
      "class": "ucd-actionBar",
      "style": simplifiedAction ? 'opacity: 0.4' : '',
      "attrs": {
        "tabIndex": "2",
        "comp-path": compPath
      },
      "on": {
        "focus": this.handleActiveBarFocus
      }
    }, [compActions.map((action, index) => {
      if (!action) return null;
      const type = getCompActionRenderType(action);
      if (type === 'separator') return h("span", ["|"]);
      if (type === 'text') return h("span", {
        "key": index
      }, [action.title]);
      return h("button", {
        "key": `action:${index}"${action.desc}`,
        "attrs": {
          "disabled": !!action.disabled,
          "title": action.desc
        },
        "class": mergeClassName('ucd-actionBar-button', !!action.highlighted && 'isHighlighted'),
        "on": {
          "click": e => designer.executeAction(action.execute, e)
        }
      }, [!!action.icon && [h("i", {
        "class": `ucd-actionBar-icon ${action.icon}`
      }), ' '], action.title]);
    })])]);
  }
};
__decorate([Watch('designer.contextMenuContent')], CompActionBar.prototype, "handleContextMenuChange", null);
CompActionBar = __decorate([Component({
  name: 'CompActionBar',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {}
})], CompActionBar);
export default CompActionBar;
//# sourceMappingURL=CompActionBar.js.map
